import { BASE_PATH as u, BaseAPI as G, operationServerMap as c } from "../base.js";
import { DUMMY_BASE_URL as d, assertParamExists as h, createRequestFunction as S, setSearchParams as v, toPathString as M } from "../common.js";
import V from "axios";
var C = function(r) {
  return {
    memberStatGetMemberConsumptionInfo: async (a, o = {}) => {
      h("memberStatGetMemberConsumptionInfo", "query", a);
      const s = new URL("/mms/stat/consumption", d);
      let e;
      r && (e = r.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, m = {}, n = {};
      if (a !== void 0) for (const [i, b] of Object.entries(a)) n[i] = b;
      v(s, n);
      let l = e && e.headers ? e.headers : {};
      return t.headers = {
        ...m,
        ...l,
        ...o.headers
      }, {
        url: M(s),
        options: t
      };
    },
    memberStatGetTotalMemberChargeView: async (a, o = {}) => {
      h("memberStatGetTotalMemberChargeView", "query", a);
      const s = new URL("/mms/stat/member/general", d);
      let e;
      r && (e = r.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, m = {}, n = {};
      if (a !== void 0) for (const [i, b] of Object.entries(a)) n[i] = b;
      v(s, n);
      let l = e && e.headers ? e.headers : {};
      return t.headers = {
        ...m,
        ...l,
        ...o.headers
      }, {
        url: M(s),
        options: t
      };
    },
    memberStatGetTotalMemberConsumptionView: async (a, o = {}) => {
      h("memberStatGetTotalMemberConsumptionView", "query", a);
      const s = new URL("/mms/stat/general", d);
      let e;
      r && (e = r.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...o
      }, m = {}, n = {};
      if (a !== void 0) for (const [i, b] of Object.entries(a)) n[i] = b;
      v(s, n);
      let l = e && e.headers ? e.headers : {};
      return t.headers = {
        ...m,
        ...l,
        ...o.headers
      }, {
        url: M(s),
        options: t
      };
    }
  };
}, p = function(r) {
  const a = C(r);
  return {
    async memberStatGetMemberConsumptionInfo(o, s) {
      var e, t;
      const m = await a.memberStatGetMemberConsumptionInfo(o, s), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, l = (t = c["MemberStatApi.memberStatGetMemberConsumptionInfo"]) === null || t === void 0 || (t = t[n]) === null || t === void 0 ? void 0 : t.url;
      return (i, b) => S(m, V, u, r)(i, l || b);
    },
    async memberStatGetTotalMemberChargeView(o, s) {
      var e, t;
      const m = await a.memberStatGetTotalMemberChargeView(o, s), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, l = (t = c["MemberStatApi.memberStatGetTotalMemberChargeView"]) === null || t === void 0 || (t = t[n]) === null || t === void 0 ? void 0 : t.url;
      return (i, b) => S(m, V, u, r)(i, l || b);
    },
    async memberStatGetTotalMemberConsumptionView(o, s) {
      var e, t;
      const m = await a.memberStatGetTotalMemberConsumptionView(o, s), n = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, l = (t = c["MemberStatApi.memberStatGetTotalMemberConsumptionView"]) === null || t === void 0 || (t = t[n]) === null || t === void 0 ? void 0 : t.url;
      return (i, b) => S(m, V, u, r)(i, l || b);
    }
  };
}, A = function(r, a, o) {
  const s = p(r);
  return {
    memberStatGetMemberConsumptionInfo(e, t) {
      return s.memberStatGetMemberConsumptionInfo(e.query, t).then((m) => m(o, a));
    },
    memberStatGetTotalMemberChargeView(e, t) {
      return s.memberStatGetTotalMemberChargeView(e.query, t).then((m) => m(o, a));
    },
    memberStatGetTotalMemberConsumptionView(e, t) {
      return s.memberStatGetTotalMemberConsumptionView(e.query, t).then((m) => m(o, a));
    }
  };
}, P = class extends G {
  memberStatGetMemberConsumptionInfo(r, a) {
    return p(this.configuration).memberStatGetMemberConsumptionInfo(r.query, a).then((o) => o(this.axios, this.basePath));
  }
  memberStatGetTotalMemberChargeView(r, a) {
    return p(this.configuration).memberStatGetTotalMemberChargeView(r.query, a).then((o) => o(this.axios, this.basePath));
  }
  memberStatGetTotalMemberConsumptionView(r, a) {
    return p(this.configuration).memberStatGetTotalMemberConsumptionView(r.query, a).then((o) => o(this.axios, this.basePath));
  }
};
export {
  P as MemberStatApi,
  C as MemberStatApiAxiosParamCreator,
  A as MemberStatApiFactory,
  p as MemberStatApiFp
};

//# sourceMappingURL=member-stat-api.js.map